import Http from '../Http';

export class ColoniaService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`colonia/filter?${params.toString()}`);
      return res.data?.rows || res.data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}
